/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".carousel-indicators[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{background-color:var(--main-color)}.typo-title[_ngcontent-%COMP%]{font-size:27px;font-family:Oswald,sans-serif;color:#333}.embed-responsive-item[_ngcontent-%COMP%]{background-size:cover;background-position:center}"];
export { styles as styles };
